import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Form from 'antd/lib/form';
import Input from 'antd/lib/input';
import Checkbox from 'antd/lib/checkbox';
import Select from 'antd/lib/select';
import Icon from 'antd/lib/icon';
import Spin from 'antd/lib/spin';
import Popover from 'antd/lib/popover';
import Button from 'antd/lib/button';
import moment from 'moment';
import {
  gendersT,
  maritalStatusesT,
  socialStatusT,
  socialStatus,
  educationT,
  accountRolesT,
  accountRegistrationStatusesT
} from '../../../../common/enums';
import rules from '../../../../common/rules/rules';
import accountRules from '../../../../common/rules/accountRules';
import { rcFieldDecoratorOptions, createRcBackspaceHandler } from '../../../../common/utils/rcMask';
import { formatDateTime, currencyFormatter } from '../../../../common/utils/helpers';
import AdditionalEmailsHelper from './AdditionalEmailsHelper';
import AdditionalPhonesHelper from './AdditionalPhonesHelper';
import { t } from '../../../../app/i18n';
import { Link } from 'react-router';

export default class CreditorProfile extends Component {

  static propTypes = {
    t: PropTypes.func.isRequired,
    account: PropTypes.object.isRequired,
    isEditable: PropTypes.bool.isRequired,
    form: PropTypes.object.isRequired,
    isFetchingIdCardInfo: PropTypes.bool.isRequired,
    updateIdCardInfo: PropTypes.func.isRequired,
    isCallCentrum: PropTypes.bool.isRequired,
    accountUpdateLogs: PropTypes.object
  };

  constructor(props) {
    super(props);

    this.state = {
      showEmployer: [
        socialStatus.EMPLOYED_INDEFINITE,
        socialStatus.EMPLOYED_DEFINITE,
        socialStatus.AGREEMENT_OTHER,
      ].includes(this.props.account.profileData.socialStatus),
    };

    this.formItemLayout = {
      labelCol: {
        xs: {
          span: 9,
        },
        sm: {
          span: 6,
        },
      },
      wrapperCol: {
        xs: {
          span: 15,
        },
        sm: {
          span: 14,
        },
      },
    };

    this.tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 14,
          offset: 6,
        },
        sm: {
          span: 14,
          offset: 6,
        },
      },
    };

    this.declarationFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 22,
          offset: 2,
        },
        sm: {
          span: 14,
          offset: 4,
        },
      },
    };
  }

  handleSocialStatusChange = value => {
    this.setState({
      showEmployer: [
        socialStatus.EMPLOYED_INDEFINITE,
        socialStatus.EMPLOYED_DEFINITE,
        socialStatus.AGREEMENT_OTHER,
      ].includes(value),
    });
  };
  getUpdateLogByAttribute = (logs, attributeName) => {
    if (logs.data && logs.data.length > 0) {
      let log = logs.data.find(l => l.attributeName == attributeName)
      if (log) {
        return t(`Naposledy zmenené: ${formatDateTime(log.lastUpdatedAt)}, zmenil ${log.updatedByName}`)
      }
    }
  }

  render() {

    const { account, form, isEditable, isFetchingIdCardInfo, updateIdCardInfo, isCallCentrum, t, accountUpdateLogs } = this.props;
    const { getFieldDecorator } = form;
    const profileData = account.profileData;
    const { showEmployer } = this.state;

    const Option = Select.Option;

    const idCardPopoverTitle = (
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h1 style={{ fontSize: '1.5rem' }}>{profileData.idCardNumber || '-'}</h1>
        <Button shape="circle" icon="reload" size="small" title="Obnoviť" onClick={updateIdCardInfo} />
      </div>
    );

    const idCardInfoPopoverContent = (
      <Spin spinning={isFetchingIdCardInfo}>
        <dl className="id-card-info-dl">
          <dt>Stav</dt>
          <dd>{account.idCardInfo ? account.idCardInfo.result : '-'}</dd>
          <dt>Posledná aktualizácia</dt>
          <dd>{account.idCardInfo ? moment(account.idCardInfo.dateChecked).format('DD.MM.YYYY HH:mm') : '-'}</dd>
        </dl>
      </Spin>
    );

    const personalNumberCheckPopoverTitle = (
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h1 style={{ fontSize: '1.1rem' }}>{'Kontrola rodného čísla'}</h1>
      </div>
    );

    const personalNumberCheckInfoPopoverContent = (
      
        <dl className="id-card-info-dl">
          <dt>Stav</dt>
          <dd>{account.personalNumberCheck.length > 0 ? 'Rovnaké rodné číslo u iných klientov' : 'OK'}</dd>
          <br/>
          {
            account.personalNumberCheck.length > 0 ? 
              account.personalNumberCheck.map(
                acc => <dd key={acc.id}>
                  <Link to={`/admin/accounts/${acc.id}/profile`}>{`${acc.firstName} ${acc.lastName}`}</Link>
                <br/></dd>)
           : <dd></dd>
          }
        </dl>
    );

    return (
      <div>
        <Form.Item {...this.tailFormItemLayout}>
          <h3>{t('Osobné údaje')}</h3>
        </Form.Item>

        <Form.Item {...this.formItemLayout} label={t('Meno')}>
          {isEditable && !isCallCentrum ? (
            getFieldDecorator('nameFirst', {
              rules: rules.required,
              initialValue: account.nameFirst,
            })(<Input size="default" placeholder={t('Meno')} autoFocus />)
          ) : (
              <span>{account.nameFirst}</span>
            )
          }
        </Form.Item>

        <Form.Item {...this.formItemLayout} label={t('Priezvisko')}>
          {isEditable && !isCallCentrum ? (
            getFieldDecorator('nameLast', {
              rules: rules.required,
              initialValue: account.nameLast,
            })(<Input size="default" placeholder={t('Priezvisko')} />)
          ) : (
              <span>{account.nameLast}</span>
            )
          }
        </Form.Item>

        <Form.Item {...this.formItemLayout} label={t('Rola')}>
          <span>{accountRolesT[account.role]}</span>
        </Form.Item>

        <Form.Item {...this.formItemLayout} label={t('Stav registrácie')}>
          <span>{accountRegistrationStatusesT[account.registrationStatus]}</span>
        </Form.Item>

        <Form.Item
          {...this.formItemLayout}
          label={t('Číslo investora / Variabilný sym.')}
        >
          <span>{account.accountNumber}</span>
        </Form.Item>

        <Form.Item {...this.formItemLayout} label={t('Deaktivovaný')}>
          {isEditable && !isCallCentrum ? (
            getFieldDecorator('locked', {
              rules: rules.required,
              initialValue: account.locked,
            })(<Checkbox defaultChecked={account.locked} />)
          ) : (
              account.locked ? t('Áno') : t('Nie')
            )}
        </Form.Item>

        <Form.Item {...this.formItemLayout} label={t('Suma na investovanie')}>
          <span>{currencyFormatter(account.balance)}</span>
        </Form.Item>

        <Form.Item {...this.formItemLayout} label={t('Dátum vytvorenia')}>
          <span>{formatDateTime(account.createdAt)}</span>
        </Form.Item>

        <Form.Item {...this.formItemLayout} label={t('Dátum úpravy')}>
          <span>{formatDateTime(account.updatedAt)}</span>
        </Form.Item>

        <Form.Item {...this.tailFormItemLayout}>
          <h3>{t('Kontaktné údaje')}</h3>
        </Form.Item>

        <Form.Item {...this.formItemLayout} label={t('E-mail')}>
          {!isEditable && <span style={{ display: 'block', lineHeight: 'initial' }}>{account.email != "" ? account.email : profileData.email}</span>}
          {isEditable && (
            getFieldDecorator('email', {
              rules: accountRules.email,
              initialValue: account.email != "" ? account.email : profileData.email,
            })(<Input size="default" placeholder={t('E-mail')} type="email" />)
          )}

          {!isEditable && <Checkbox checked={profileData.emailNotContact} disabled >{t('Nekontaktovať')}</Checkbox>}
          {isEditable && getFieldDecorator('emailNotContact', { initialValue: profileData.emailNotContact, valuePropName: 'checked' })(
            <Checkbox style={{ marginRight: 10 }}>{t('Nekontaktovať')}</Checkbox>
          )}

          {!isEditable && <Checkbox checked={profileData.emailAnotherPerson} disabled >{t('Iná osoba')}</Checkbox>}
          {isEditable && getFieldDecorator('emailAnotherPerson', { initialValue: profileData.emailAnotherPerson, valuePropName: 'checked' })(
            <Checkbox style={{ marginRight: 10 }}>{t('Iná osoba')}</Checkbox>
          )}

          {!isEditable && <Checkbox checked={profileData.emailUndeliverable} disabled >{t('Nedoručiteľný')}</Checkbox>}
          {isEditable && getFieldDecorator('emailUndeliverable', { initialValue: profileData.emailUndeliverable, valuePropName: 'checked' })(
            <Checkbox>{t('Nedoručiteľný')}</Checkbox>
          )}
        </Form.Item>

        <AdditionalEmailsHelper account={account} isEditable={isEditable} isCallCentrum={isCallCentrum} form={form}></AdditionalEmailsHelper>

        <Form.Item {...this.formItemLayout} label={t('Telefónne číslo')}>
          {!isEditable && <span style={{ display: 'block', lineHeight: 'initial' }}>{profileData.phone}</span>}
          {isEditable &&
            getFieldDecorator('phone', {
              rules: accountRules.telephoneNumber,
              initialValue: profileData.phone,
            })(<Input size="default" placeholder={t('090x xxx xxx')} />)}

          {!isEditable && <Checkbox checked={profileData.phoneActive} disabled>{t('Aktívne')}</Checkbox>}
          {isEditable && getFieldDecorator('phoneActive', { initialValue: profileData.phoneActive, valuePropName: 'checked' })(
            <Checkbox style={{ marginRight: 10 }}>{t('Aktívne')}</Checkbox>
          )}

          {!isEditable && <Checkbox checked={profileData.phonePrefered} disabled >{t('Preferované')}</Checkbox>}
          {isEditable && getFieldDecorator('phonePrefered', { initialValue: profileData.phonePrefered, valuePropName: 'checked' })(
            <Checkbox style={{ marginRight: 10 }}>{t('Preferované')}</Checkbox>
          )}

          {!isEditable && <Checkbox checked={profileData.phoneChecked} disabled >{t('Overené')}</Checkbox>}
          {isEditable && getFieldDecorator('phoneChecked', { initialValue: profileData.phoneChecked, valuePropName: 'checked' })(
            <Checkbox style={{ marginRight: 10 }}>{t('Overené')}</Checkbox>
          )}

          {!isEditable && <Checkbox checked={profileData.phoneNotContact} disabled >{t('Nekontaktovať')}</Checkbox>}
          {isEditable && getFieldDecorator('phoneNotContact', { initialValue: profileData.phoneNotContact, valuePropName: 'checked' })(
            <Checkbox style={{ marginRight: 10 }}>{t('Nekontaktovať')}</Checkbox>
          )}

          {!isEditable && <Checkbox checked={profileData.phoneAnotherPerson} disabled >{t('Iná osoba')}</Checkbox>}
          {isEditable && getFieldDecorator('phoneAnotherPerson', { initialValue: profileData.phoneAnotherPerson, valuePropName: 'checked' })(
            <Checkbox>{t('Iná osoba')}</Checkbox>
          )}
        </Form.Item>

        <AdditionalPhonesHelper account={account} isEditable={isEditable} isCallCentrum={isCallCentrum} form={form}></AdditionalPhonesHelper>

        <Form.Item {...this.tailFormItemLayout}>
          <h4>{t('Adresa')}</h4>
        </Form.Item>

        <Form.Item {...this.formItemLayout} label={t('Ulica a číslo')}>
          {!isEditable && <span>{profileData.address.street}</span>}
          {isEditable &&
            getFieldDecorator('address.street', {
              initialValue: profileData.address.street,
            })(<Input size="default" placeholder={t('Ulica a číslo')} />)}
        </Form.Item>

        <Form.Item {...this.formItemLayout} label={t('Mesto')}>
          {!isEditable && <span>{profileData.address.city}</span>}
          {isEditable &&
            getFieldDecorator('address.city', {
              initialValue: profileData.address.city,
            })(<Input size="default" placeholder={t('Mesto')} />)}
        </Form.Item>

        <Form.Item {...this.formItemLayout} label={t('PSČ')}>
          {!isEditable && <span>{profileData.address.zip}</span>}
          {isEditable &&
            getFieldDecorator('address.zip', {
              rules: [...rules.required, ...accountRules.zip],
              initialValue: profileData.address.zip,
            })(<Input size="default" placeholder={t('PSČ')} />)}
        </Form.Item>

        <Form.Item {...this.tailFormItemLayout}>
          <h4>{t('Doručovacia adresa')}</h4>
        </Form.Item>

        <Form.Item {...this.formItemLayout} label={t('Ulica a číslo')}>
          {!isEditable && <span>{profileData.deliveryAddress && profileData.deliveryAddress.street}</span>}
          {isEditable &&
            getFieldDecorator('deliveryAddress.street', {
              initialValue: profileData.deliveryAddress && profileData.deliveryAddress.street,
            })(<Input size="default" placeholder={t('Ulica a číslo')} />)}
        </Form.Item>

        <Form.Item {...this.formItemLayout} label={t('Mesto')}>
          {!isEditable && <span>{profileData.deliveryAddress && profileData.deliveryAddress.city}</span>}
          {isEditable &&
            getFieldDecorator('deliveryAddress.city', {
              initialValue: profileData.deliveryAddress && profileData.deliveryAddress.city,
            })(<Input size="default" placeholder={t('Mesto')} />)}
        </Form.Item>

        <Form.Item {...this.formItemLayout} label={t('PSČ')}>
          {!isEditable && <span>{profileData.deliveryAddress && profileData.deliveryAddress.zip}</span>}
          {isEditable &&
            getFieldDecorator('deliveryAddress.zip', {
              rules: accountRules.zip,
              initialValue: profileData.deliveryAddress && profileData.deliveryAddress.zip,
            })(<Input size="default" placeholder={t('PSČ')} />)}
        </Form.Item>

        <Form.Item {...this.tailFormItemLayout}>
          <h3>{t('Ostatné')}</h3>
        </Form.Item>

        <Form.Item {...this.formItemLayout} label={t('Rodné číslo')}>
          {isEditable && !isCallCentrum ? (
              getFieldDecorator('personalNumber', {
                rules: accountRules.personalNumber,
                initialValue: profileData.personalNumber,
                ...rcFieldDecoratorOptions,
              })(<Input size="default" placeholder={t('rrmmddxxxx')} onKeyDown={createRcBackspaceHandler(form, 'personalNumber')} />)
            ) : (
              <div>
                <span>{profileData.personalNumber}</span>
                {
                  account.personalNumberCheck.length > 0 &&
                  <Popover content={personalNumberCheckInfoPopoverContent} title={personalNumberCheckPopoverTitle} placement="rightBottom">
                    <Icon type="close-circle" style={{ marginLeft: '1rem', color: 'red' }}/>
                  </Popover>
                }
                
              </div>
              
            )
          }
        </Form.Item>

        <Form.Item {...this.formItemLayout} label={t('Číslo OP')}>
          {isEditable && !isCallCentrum ? (
            getFieldDecorator('idCardNumber', {
              rules: accountRules.idCardNumber,
              initialValue: profileData.idCardNumber,
            })(<Input size="default" placeholder={t('Číslo OP')} />
            )) : (
              <div>
                <span>{profileData.idCardNumber}</span>
                <Popover content={idCardInfoPopoverContent} title={idCardPopoverTitle} placement="rightBottom">
                  {isFetchingIdCardInfo && <Icon type="loading" style={{ marginLeft: '1rem' }} />}
                  {!isFetchingIdCardInfo && (!account.idCardInfo || account.idCardInfo.status === 'NEUTRAL') &&
                    <Icon type="question-circle" style={{ marginLeft: '1rem', color: 'orange' }} />
                  }
                  {!isFetchingIdCardInfo && account.idCardInfo && account.idCardInfo.status === 'GOOD' &&
                    <Icon type="check-circle" style={{ marginLeft: '1rem', color: 'limegreen' }} />
                  }
                  {!isFetchingIdCardInfo && account.idCardInfo && account.idCardInfo.status === 'BAD' &&
                    <Icon type="close-circle" style={{ marginLeft: '1rem', color: 'red' }} />
                  }
                </Popover>
              </div>
            )
          }
        </Form.Item>

        <Form.Item {...this.formItemLayout} label={t('IBAN')}>
          {isEditable && !isCallCentrum ? (
            getFieldDecorator('iban', {
              rules: accountRules.iban,
              initialValue: profileData.iban,
            })(<Input size="default" placeholder={t('IBAN')} />)
          ) : (
              <span>{profileData.iban}</span>
            )
          }
        </Form.Item>

        <Form.Item {...this.formItemLayout} label={t('Marketingový kód')}>
          <span>{account.marketingCode}</span>
        </Form.Item>

        <Form.Item {...this.formItemLayout} label={t('Vzdelanie')}>
          {isEditable && !isCallCentrum ? (
            getFieldDecorator('education', {
              initialValue: profileData.education,
            })(
              <Select size="default" placeholder={t('Vyberte vzdelanie')}>
                {Object.entries(educationT).map(([key, value]) => (
                  <Option key={key} value={key}>
                    {value}
                  </Option>
                ))}
              </Select>
            )) : (
              <span>{educationT[profileData.education]}</span>
            )
          }
        </Form.Item>

        <Form.Item {...this.formItemLayout} label={t('Úroková miera pre pôžičky od 0 do 6 mes.')}>
          {!isEditable && <div><span>{account.interest0_6}</span> <span className="update-log">{this.getUpdateLogByAttribute(accountUpdateLogs, 'interest0_6')}</span></div>}
          {isEditable &&
            getFieldDecorator('interest0_6', {
              rules: rules.required,
              initialValue: account.interest0_6,
            })(<Input size="default" placeholder={t('Úroková miera pre pôžičky od 0 do 6 mes.')} />)}
        </Form.Item>

        <Form.Item {...this.formItemLayout} label={t('Úroková miera pre pôžičky od 6 do 12 mes.')}>
          {!isEditable && <div><span>{account.interest6_12}</span> <span className="update-log">{this.getUpdateLogByAttribute(accountUpdateLogs, 'interest6_12')}</span></div>}
          {isEditable &&
            getFieldDecorator('interest6_12', {
              rules: rules.required,
              initialValue: account.interest6_12,
            })(<Input size="default" placeholder={t('Úroková miera pre pôžičky od 6 do 12 mes.')} />)}
        </Form.Item>

        <Form.Item {...this.formItemLayout} label={t('Úroková miera pre pôžičky od 12 do 24 mes.')}>
          {!isEditable && <div><span>{account.interest12_24}</span> <span className="update-log">{this.getUpdateLogByAttribute(accountUpdateLogs, 'interest12_24')}</span></div>}
          {isEditable &&
            getFieldDecorator('interest12_24', {
              rules: rules.required,
              initialValue: account.interest12_24,
            })(<Input size="default" placeholder={t('Úroková miera pre pôžičky od 12 do 24 mes.')} />)}
        </Form.Item>

        <Form.Item {...this.formItemLayout} label={t('Úroková miera pre pôžičky od 24 do 36 mes.')}>
          {!isEditable && <div><span>{account.interest24_36}</span> <span className="update-log">{this.getUpdateLogByAttribute(accountUpdateLogs, 'interest24_36')}</span></div>}
          {isEditable &&
            getFieldDecorator('interest24_36', {
              rules: rules.required,
              initialValue: account.interest24_36,
            })(<Input size="default" placeholder={t('Úroková miera pre pôžičky od 24 do 36 mes.')} />)}
        </Form.Item>

        <Form.Item {...this.formItemLayout} label={t('Úroková miera pre pôžičky od 36 do 48 mes.')}>
          {!isEditable && <div><span>{account.interest36_48}</span> <span className="update-log">{this.getUpdateLogByAttribute(accountUpdateLogs, 'interest36_48')}</span></div>}
          {isEditable &&
            getFieldDecorator('interest36_48', {
              rules: rules.required,
              initialValue: account.interest36_48,
            })(<Input size="default" placeholder={t('Úroková miera pre pôžičky od 36 do 48 mes.')} />)}
        </Form.Item>

        <Form.Item {...this.formItemLayout} label={t('Úroková miera pre pôžičky od 48 do 60 mes.')}>
          {!isEditable && <div><span>{account.interest48_60}</span> <span className="update-log">{this.getUpdateLogByAttribute(accountUpdateLogs, 'interest48_60')}</span></div>}
          {isEditable &&
            getFieldDecorator('interest48_60', {
              rules: rules.required,
              initialValue: account.interest48_60,
            })(<Input size="default" placeholder={t('Úroková miera pre pôžičky od 48 do 60 mes.')} />)}
        </Form.Item>

        <Form.Item {...this.formItemLayout} label={t('Bonus investora - Aktívny')}>
          {isEditable && !isCallCentrum ? (
            getFieldDecorator('interestBonusEnabled', {
              rules: rules.required,
              initialValue: account.interestBonusEnabled,
            })(<Checkbox defaultChecked={account.interestBonusEnabled} />)
          ) : (
            account.interestBonusEnabled ? t('Áno') : t('Nie')
          )}
        </Form.Item>

        <Form.Item {...this.formItemLayout} label={t('Bonus investora - hodnota')}>
          {!isEditable && <div><span>{account.interestBonusValue}</span> <span className="update-log">{this.getUpdateLogByAttribute(accountUpdateLogs, 'interestBonusValue')}</span></div>}
          {isEditable &&
            getFieldDecorator('interestBonusValue', {
              rules: accountRules.interestBonusValue,
              initialValue: account.interestBonusValue,
            })(<Input size="default" placeholder={t('Bonus investora - hodnota')} />)}
        </Form.Item>

        <Form.Item {...this.tailFormItemLayout}>
          <h3>{t('Prehlásenia')}</h3>
        </Form.Item>

        <Form.Item {...this.declarationFormItemLayout}>
          {!isEditable && <Checkbox defaultChecked={profileData.declarationOfLegalIncome} disabled />}
          {isEditable &&
            getFieldDecorator('declarationOfLegalIncome', {
              rules: rules.required,
              initialValue: profileData.declarationOfLegalIncome,
            })(<Checkbox defaultChecked={profileData.declarationOfLegalIncome} />)}
          <span>{t('Prehlasujem, že príjmy na investovanie nepochádzajú z trestnej činnosti.')}</span>
        </Form.Item>
      </div>
    );
  }
};



// WEBPACK FOOTER //
// ./src/features/account-management/components/profile/CreditorProfile.js